import { Tab } from '@headlessui/react'
import classNames from 'classnames'
import React from 'react'
interface ICustomTab {
  tabNumber?: number
  title?: string
  error?: Record<string, any>
  children?: React.ReactNode
  showTabNumberIcon?: boolean
  selectColorText?: string
  selectedColorBackground?: string
  selectedColorBorder?: string
  onClick?: () => void
}

export const CustomTab = ({
  tabNumber,
  title,
  error,
  showTabNumberIcon = false,
  selectedColorBackground = 'bg-black-500',
  selectColorText = 'text-black-400',
  selectedColorBorder = 'border-red',
  onClick
}: ICustomTab) => {
  let hasErrors: boolean

  if (error) {
    hasErrors = Object.keys(error).length > 0
  }
  const selectedBorder = `border-b-4 ${selectedColorBorder} ${selectColorText}`
  return (
    <Tab
      className='py-1 text-sm leading-2 font-medium text-black mr-2 focus:outline-none pt-6'
      onClick={onClick}
    >
      {({ selected }) => (
        <div className='flex flex-col justify-center items-center'>
          {showTabNumberIcon && (
            <div
              className={classNames(
                'flex flex-col justify-center items-center text-center border rounded-full h-6 w-6 font-bold  text-white border-transparent',
                {
                  [selectedColorBackground]: selected,
                  'bg-red-500': hasErrors,
                  'bg-gray-400': !selected,
                  'bg-red-200': !selected && hasErrors
                }
              )}
            >
              {tabNumber}
            </div>
          )}
          <div
            className={classNames(
              'mt-2 font-bold w-16 md:w-36 lg:w-48  whitespace-nowrap truncate text-ellipsis md:block',
              {
                [selectColorText]: selected,
                'text-red-500': hasErrors && selected,
                'text-red-200': hasErrors && !selected,
                'text-gray-400': !selected
              }
            )}
          >
            {title && !tabNumber ? title : `${title} ${tabNumber}`}
          </div>
          <div
            className={classNames('pt-3 w-full', {
              [selectedBorder]: selected,
              'border-b-4 border-gray text-gray': !selected,
              'border-b-4 border-red-500 text-red-500': hasErrors && selected,
              'border-b-4 border-red-200 text-red-200': hasErrors && !selected
            })}
          />
        </div>
      )}
    </Tab>
  )
}
